<template>
  <div>
    <validation-observer ref="refFormObserver">
      <b-form>
        <b-row class="mx-0">
          <b-col cols="12">
            <!-- Master Account -->
            <validation-provider
              #default="validationContext"
              name="vxg_master_account"
              rules="required"
            >
              <b-form-group
                :label="$tc('vxg_master_account.title', 1)"
                label-for="vxg_master_account"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  v-model="itemData.id_vxg_master_account"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="vxgMasterAccountOptions"
                  :reduce="(val) => val.value"
                  input-id="vxg_master_account"
                  :clearable="false"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!-- Nombre -->
            <validation-provider
              #default="validationContext"
              name="name"
              rules="required"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('vxg_camera.name')"
                label-for="name"
              >
                <b-form-input
                  id="name"
                  v-model="itemData.name"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!-- Nombre -->
            <validation-provider #default="validationContext" name="ip">
              <b-form-group
                class="text-capitalize"
                :label="$t('vxg_camera.ip')"
                label-for="IP"
              >
                <b-form-input
                  id="IP"
                  v-model="itemData.ip"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row class="mx-0">
          <b-col cols="6">
            <!-- Type -->
            <validation-provider
              #default="validationContext"
              name="Type"
              rules="required"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('camera.type')"
                label-for="id_type"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  v-model="itemData.id_type"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="typeOptions"
                  :reduce="(option) => option.value"
                  :getOptionKey="(option) => option.value"
                  :clearable="false"
                  input-id="id_type"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!-- Tags -->
            <validation-provider #default="validationContext" name="Tag">
              <b-form-group
                class="text-capitalize"
                label="Tag"
                label-for="id_device_tag"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  v-model="itemData.id_device_tag"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="deviceTagsOptions"
                  :clearable="false"
                  :reduce="(val) => val.value"
                  input-id="id_device_tag"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row class="mx-0">
          <b-col cols="6">
            <!-- Record Type -->
            <validation-provider
              #default="validationContext"
              name="record_type"
              rules="required"
            >
              <b-form-group
                :label="$tc('vxg_master_account.record_type', 1)"
                label-for="record_type"
                class="text-capitalize"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  v-model="itemData.record_type"
                  :options="recordTypeOptions"
                  :reduce="(val) => val.value"
                  input-id="record_type"
                  :clearable="false"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12">
            <!--  Url server-->
            <validation-provider
              #default="validationContext"
              name="vxg_master_url_source"
              v-if="selectedRecordTypeFields.url_server"
            >
              <b-form-group
                :label="$tc('vxg_master_account.url', 1).toLowerCase()"
                label-for="vxg_master_url_source"
                :state="getValidationState(validationContext)"
              >
                <b-input-group>
                  <b-input-group-prepend
                    is-text
                    class="text-lowercase"
                    style="text-transform: lowercase"
                  >
                    {{ baseMasterAccountUrl }}
                  </b-input-group-prepend>
                  <b-form-input
                    id="masterAccoutUrlSuffix"
                    v-model="masterUrlSuffix"
                    :state="getValidationState(validationContext)"
                    :placeholder="uplinkSuffixPlaceholder"
                    trim
                  />
                </b-input-group>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12">
            <!-- URL -->
            <validation-provider
              #default="validationContext"
              name="url"
              :rules="{
                required: selectedRecordTypeFields.url,
                camera_source_url: { type: itemData.record_type },
              }"
              v-if="selectedRecordTypeFields.url"
            >
              <b-form-group label="URL" label-for="url">
                <b-input-group :prepend="selectedRecordTypeFields.value == 'onvif' ? 'onvif://':''">
                  <b-form-input
                    id="url"
                    v-model="itemData.url"
                    :state="getValidationState(validationContext)"
                    trim
                    :placeholder="selectedRecordTypeFields.url_placeholder"
                  />
                  <b-input-group-append
                    v-if="itemData.record_type == 'onvif'">
                    <b-form-input
                      id="path_onvif"
                      v-model="itemData.path_onvif"
                      :state="getValidationState(validationContext)"
                      trim
                    />
                  </b-input-group-append>
                </b-input-group>

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row class="mx-0">
          <b-col cols="6">
            <validation-provider
              #default="validationContext"
              :name="$t('users.username')"
              :rules="{ required: selectedRecordTypeFields.user }"
              v-if="selectedRecordTypeFields.user"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('users.username')"
                label-for="username"
              >
                <b-form-input
                  id="username"
                  v-model="itemData.username"
                  :state="getValidationState(validationContext)"
                  trim
                  autocomplete="off"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!-- Password -->
            <validation-provider
              #default="validationContext"
              name="password"
              :rules="{ required: selectedRecordTypeFields.pass }"
              v-if="selectedRecordTypeFields.pass"
            >
              <b-form-group class="text-capitalize" label="Password" label-for="password">
                <b-form-input
                  id="password"
                  v-model="itemData.password"
                  :state="getValidationState(validationContext)"
                  name="password"
                  type="password"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row class="mx-0">
          <b-col cols="6">
            <!-- Serial Number -->
            <validation-provider
              #default="validationContext"
              name="serial_number"
              v-if="selectedRecordTypeFields.serial_number"
            >
              <b-form-group
                class="text-capitalize"
                label="Serial Number"
                label-for="serial_number"
              >
                <b-form-input
                  id="serial_number"
                  v-model="itemData.serial_number"
                  :state="getValidationState(validationContext)"
                  trim
                  :disabled="!isAdd"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!-- MAC Address -->
            <validation-provider
              #default="validationContext"
              name="mac_address"
              v-if="selectedRecordTypeFields.mac"
            >
              <b-form-group
                class="text-capitalize"
                label="MAC Address"
                label-for="mac_address"
              >
                <b-form-input
                  id="mac_address"
                  v-model="itemData.mac_address"
                  :state="getValidationState(validationContext)"
                  trim
                  :disabled="!isAdd"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row class="mx-0">
          <b-col cols="6">
            <!-- Type -->
            <validation-provider
              #default="validationContext"
              name="Type"
              rules="required"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('camera.type')"
                label-for="id_type"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  v-model="itemData.id_type"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="typeOptions"
                  :reduce="(option) => option.value"
                  :getOptionKey="(option) => option.value"
                  :clearable="false"
                  input-id="id_type"
                  data-cy="type_select"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!-- Tags -->
            <validation-provider #default="validationContext" name="Tag">
              <b-form-group
                class="text-capitalize"
                label="Tag"
                label-for="id_device_tag"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  v-model="itemData.id_device_tag"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="deviceTagsOptions"
                  :clearable="false"
                  :reduce="(val) => val.value"
                  input-id="id_device_tag"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="6">
            <validation-provider name="send_to_seproban" rules="required" vid="send_to_seproban">
              <b-form-checkbox
                id="send_to_seproban"
                v-model="itemData.send_to_seproban"
                name="send_to_seproban"
                value="1"
                class="my-1 text-capitalize"
                unchecked-value="0"
                switch
              >
                {{ $t("camera_proxy.send_to_seproban") }}
              </b-form-checkbox>
            </validation-provider>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import formValidation from "@core/comp-functions/forms/form-validation";
import vSelect from "vue-select";
import { ref, computed, onMounted, watch } from "@vue/composition-api";
import store from "@/store";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import {
  getCameraSourceUrlError,
  parseCameraSourceUrl,
} from "../cameraSourceUrl";

extend("camera_source_url", {
  params: ["type"],
  validate: (value, { type }) => !getCameraSourceUrlError(type, value),
  message: "La URL no corresponde al tipo de registro seleccionado.",
});

const isMacAddress = (str) => {
  // MAC address regex pattern (matches XX:XX:XX:XX:XX:XX or XX-XX-XX-XX-XX-XX format)
  const macRegex = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/;
  return macRegex.test(str);
};

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
  },
  props: {
    vxgMasterAccountOptions: {
      type: Array,
      required: true,
      default: () => [],
    },
    vxgMasterAccountApiServerOptions: {
      type: Array,
      required: true,
      default: () => [],
    },
    typeOptions: {
      type: Array,
      required: true,
      default: () => [],
    },
    isAdd: {
      type: Boolean,
      required: false,
      default: false,
    },
    propItemData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    propResData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    onMounted(() => store.dispatch('tenant/getDeviceTags'));

    const { t } = useI18nUtils();
    const { refFormObserver, getValidationState } = formValidation();
    const hydrateItemData = (source = {}) => {
      const cameraType = source.cameraType ?? {};
      const serialNumber = source.serial_number ?? cameraType.serial_number ?? "";

      return {
        ...source,
        password: source.password ?? cameraType.password ?? "",
        username: source.username ?? cameraType.user ?? "",
        url: source.url ?? cameraType.url ?? "",
        http_port: source.http_port ?? cameraType.http_port ?? "",
        rtps_port: source.rtps_port ?? cameraType.rtps_port ?? "",
        mac_address:
          source.mac_address ?? (isMacAddress(serialNumber) ? serialNumber : ""),
        serial_number: isMacAddress(serialNumber) ? "" : serialNumber,
        uplink: source.record_type === "uplink" || source.type === "uplink",
        record_type: source.record_type || cameraType.type || source.type || "",
        vxg_master_url_source: source.vxg_master_url_source ?? "",
      };
    };

    const itemData = ref(hydrateItemData(props.propItemData));
    const cameraTypeData = ref(props.propItemData?.cameraType ?? {});

    const resData = ref(props.propResData);
    const initialData = ref({ ...itemData.value });

    const hasChanges = (key) => {
      return itemData.value[key] !== initialData.value[key];
    };

    const recordTypeOptions = [
      {
        label: "RTSP",
        value: "rtsp",
        user: true,
        pass: true,
        url: true,
        http_port: false,
        rtps_port: false,
        mac: false,
        serial_number: false,
        url_server: false,
        url_placeholder: "rtsp://0.0.0.0",
      },
      {
        label: "ONVIF",
        value: "onvif",
        user: true,
        pass: true,
        url: true,
        http_port: true,
        rtps_port: true,
        mac: false,
        serial_number: false,
        url_server: false,
        url_placeholder: "0.0.0.0:80",
      },
      {
        label: "Uplink",
        value: "uplink",
        user: true,
        pass: true,
        url: false,
        http_port: false,
        rtps_port: false,
        mac: true,
        serial_number: true,
        url_server: true,
      },
      {
        label: "Plug-in",
        value: "plug-in",
        user: true,
        pass: true,
        url: false,
        http_port: false,
        rtps_port: false,
        mac: false,
        serial_number: false,
        url_server: false,
      },
      {
        label: "Router",
        value: "router",
        user: true,
        pass: true,
        url: false,
        http_port: false,
        rtps_port: false,
        mac: false,
        serial_number: false,
        url_server: true,
      },
    ];

    const selectedRecordTypeFields = computed(() => {
      const defaultFields = {
        user: false,
        pass: false,
        url: false,
        http_port: false,
        rtps_port: false,
        mac: false,
        serial_number: false,
        url_server: false,
        url_placeholder: "rtsp://0.0.0.0",
      };

      if (!itemData.value.record_type) return defaultFields;

      return (
        recordTypeOptions.find((option) => option.value === itemData.value.record_type) ||
        {}
      );
    });

    const validateStep = () => {
      return refFormObserver.value.validate();
    };

    watch(
      () => props.propItemData,
      (newValue) => {
        const hydratedData = hydrateItemData(newValue);
        cameraTypeData.value = newValue?.cameraType ?? {};
        initialData.value = { ...hydratedData };
        itemData.value = hydratedData;
      },
      { deep: true }
    );

    watch(
      () => itemData.value.url,
      (newValue) => {
        if (itemData.value.record_type !== "onvif" || !/^onvif:\/\//i.test(newValue)) {
          return;
        }

        const parsed = parseCameraSourceUrl(
          "onvif",
          newValue,
          itemData.value.path_onvif
        );
        itemData.value.url = parsed.url;
        itemData.value.path_onvif = parsed.path;
      }
    );

    const setupWatcher = (itemData, key) => {
      watch(
        () => itemData.value[key],
        (newValue, oldValue) => {
          if (newValue !== oldValue && hasChanges(key)) {
            emit("update:itemData", { [key]: newValue });
          }
        }
      );
    };

    const extractBaseBeforeUplink = (url) => {
      const marker = "/uplink_camera/";
      const str = (url || "").toLowerCase();
      const idx = str.indexOf(marker);
      return idx === -1 ? str : str.substring(0, idx + marker.length);
    };

    const extractSuffixAfterUplink = (url) => {
      const marker = "/uplink_camera/";
      const str = url || "";
      const lower = str.toLowerCase();
      const idx = lower.indexOf(marker);
      return idx === -1 ? "" : str.substring(idx + marker.length);
    };

    const baseMasterAccountUrl = computed(() => {
      const id = itemData.value?.id_vxg_master_account;
      if (!id) return "";
      const match = props.vxgMasterAccountApiServerOptions?.find(
        (o) => Number(o.value) === Number(id)
      );
      const label = match?.label || "";
      return extractBaseBeforeUplink(label);
    });

    const masterUrlSuffix = ref(props.propItemData?.vxg_master_url_source || "");

    const uplinkSuffixPlaceholder = computed(() => {
      const candidates = [
        itemData.value?.url,
        cameraTypeData.value?.url,
        props.propItemData?.cameraType?.url,
        props.propItemData?.url,
      ];
      for (const url of candidates) {
        const suffix = extractSuffixAfterUplink((url || "").toString());
        if (suffix) return suffix;
      }
      const id = itemData.value?.id_vxg_master_account;
      const match = props.vxgMasterAccountApiServerOptions?.find(
        (o) => Number(o.value) === Number(id)
      );
      return extractSuffixAfterUplink(match?.label || "");
    });

    const fullMasterAccountUrl = computed(() => {
      return (baseMasterAccountUrl.value || "") + (masterUrlSuffix.value || "");
    });

    // Store only the suffix in itemData (can be empty string)
    watch(
      masterUrlSuffix,
      (suffix) => {
        const sanitized = (suffix || "").replace(/^\/+/, "");
        if (sanitized !== suffix) masterUrlSuffix.value = sanitized;
        emit("update:itemData", { vxg_master_url_source: sanitized });
      },
      { immediate: true }
    );

    // Optional: if someone pastes the full base into the suffix, strip it
    watch(masterUrlSuffix, (val) => {
      const base = baseMasterAccountUrl.value || "";
      if (!val) return;
      if (val.includes(base)) {
        masterUrlSuffix.value = val.split(base).join("");
      }
    });

    setupWatcher(itemData, "name");
    setupWatcher(itemData, "id_vxg_master_account");
    setupWatcher(itemData, "record_type");
    setupWatcher(itemData, "uplink");
    setupWatcher(itemData, "url");
    setupWatcher(itemData, "username");
    setupWatcher(itemData, "password");
    setupWatcher(itemData, "serial_number");
    setupWatcher(itemData, "mac_address");
    setupWatcher(itemData, "stream_live");
    setupWatcher(itemData, "stream_recording");
    setupWatcher(itemData, "id_type");
    setupWatcher(itemData, "type");
    setupWatcher(itemData, "id_device_tag");
    setupWatcher(itemData, "ip");
    setupWatcher(itemData, "send_to_seproban");
    setupWatcher(itemData, "vxg_master_url_source");
    setupWatcher(itemData, "path_onvif");

    const deviceTagsOptions = computed(() => {
      const tags = store.getters["tenant/getDeviceTags"] || [];
      return tags.map((item) => ({
        label: item?.name || "",
        value: item?.id,
      }));
    });

    itemData.value.mac_address = itemData.value.mac_address;
    itemData.value.serial_number = itemData.value.serial_number;
    emit("update:itemData", { mac_address: itemData.value.mac_address });
    emit("update:itemData", { serial_number: itemData.value.serial_number });

    return {
      t,
      refFormObserver,
      getValidationState,
      validateStep,
      deviceTagsOptions,
      itemData,
      recordTypeOptions,
      selectedRecordTypeFields,
      cameraTypeData,
      fullMasterAccountUrl,
      baseMasterAccountUrl,
      masterUrlSuffix,
      uplinkSuffixPlaceholder,
    };
  },
};
</script>
